module.exports = __webpack_public_path__ + "img/solo_9606modifHD.8fa50c0f.jpg";